import { useEffect, useState } from 'react';
import Head from 'next/head';

function verifyRedirect() {
  if (typeof window === 'undefined') {
    return null;
  }

  const currentSearch = window.location.search;

  return currentSearch;
}

const Leadership = () => {
  const [pathURL, setPathURL] = useState(null);

  useEffect(() => {
    const searchInfo = verifyRedirect();
    if (searchInfo) {
      setPathURL('/' + searchInfo);
      window.location.href = pathURL;
    } else {
      window.location.href = '/';
    }
  }, [pathURL]);

  return (
    <Head>
      {pathURL && (
        <meta httpEquiv="refresh" content={`0;url=${pathURL}`}></meta>
      )}
    </Head>
  );
};

export default Leadership;
